import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useCharterResponse = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const sendCharterResponse = async ({ requestId, body }) => {
    if (!token) throw new Error("Token is missing");
    if (!requestId) throw new Error("Request ID is required");
    if (!body.canProvideSecurity && !body.vesselOwnerResponse) {
      throw new Error("Either canProvideSecurity or vesselOwnerResponse is required");
    }
    
    const endpoint = `${process.env.REACT_APP_SERVER_URL}/charter/vesselOwner/charterResponse/${requestId}`;
    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to send charter response");
    }
    return data;
  };

  const {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  } = useMutation(sendCharterResponse, {
    onSuccess: () => {
      // Invalidate and refetch charter requests to get updated data
      queryClient.invalidateQueries(["readAllCharterRequestsVesselOwner"]);
      queryClient.invalidateQueries(["readCharterRequestVesselOwner"]);
    },
  });

  return {
    sendCharterResponse: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export default useCharterResponse; 